import { jsonp, ajax } from '@ifeng/ui_base';
import { formatImage } from '../../pc/utils/formatImg';
const { GETLINKTYPE } = require('./client');

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;
/* eslint-enable no-undef */

// if (/\.shank\.ifeng\.com/.test(window.location.hostname)) {
//     apiBaseUrl = '/c';
// }

const getQueryString = (paramKey, defaultV) => {
    let sURLVariables = '';
    let i = 0;
    let sParameterName = '';
    const sPageURL = window.location.search.substring(1);

    if (sPageURL.match(/&/)) {
        sURLVariables = sPageURL.split('&');
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === paramKey) return sParameterName[1];
        }
    } else {
        if (typeof defaultV !== 'undefined') return defaultV;

        sURLVariables = sPageURL.split('=');

        return sURLVariables[1];
    }
};

const getTopicData = async () => {
    return await jsonp('//c1.m.ifeng.com/topicDetail', {
        data: {
            tid: getQueryString('tid'),
        },
        jsonpCallback: 'topicDataFn',
        cache: true,
    });
};

const getSpecialData = async () => {
    return await jsonp('//c1.m.ifeng.com/TopicApiForCmpp', {
        data: {
            topicid: getQueryString('topicid'),
            json: 'y',
            ad: 'y',
        },
        jsonpCallback: 'sepcialFn',
        cache: true,
    });
};

const getCommentData = async (num, hot, commentId) => {
    return await jsonp('//comment.ifeng.com/v3/get/comments', {
        data: {
            format: 'js',
            p: num || 1,
            doc_url: commentId,
            orderby: hot || 'integral',
        },
        jsonpCallback: 'commentData',
        cache: false,
    });
};

const wxShareData = async () => {
    return await jsonp('//api.3g.ifeng.com/weishare_token_api', {
        data: {
            url: window.location.href,
        },
        jsonpCallback: 'wxshareCallback',
        cache: false,
    });
};

// 获取自媒体个人主页数据
const getWeMediaPersonalData = async params => {
    const data = await jsonp('//user.iclient.ifeng.com/Social_Api_Feeds/myFeeds', {
        data: params,
        jsonpCallback: 'showData',
        cache: false,
    });

    return data ? data : null;
};

// 获取自媒体个人详情页数据
const getWeMediaPersonalDetailData = async params => {
    const data = await jsonp('//user.iclient.ifeng.com/Social_Api_Feeds/feeddetail', {
        data: params,
        jsonpCallback: 'showData',
        cache: false,
    });

    return data ? data : null;
};

// 专题页页面信息
const getIfengNewsTopicData = async params => {
    const data = await jsonp(
        `//c1.m.ifeng.com/TopicApiForCmpp?topicid=${params.topicid}&json=y&ad=y&gv=5.7.2&av=5.7.2`,
        {
            jsonpCallback: 'ifengNewsTopicCb',
            cache: true,
        },
    );

    return data ? data : null;
};

// 获取自媒体个人详情页评论列表数据
const getCommitDataApi = async params => {
    const data = await jsonp('//comment.ifeng.com/v3/get/comments', {
        data: params,
        jsonpCallback: 'commitData',
        cache: false,
    });

    return data ? data : null;
};

// 页底焦点图数据
const bottomSlideData = async config => {
    if (!config) {
        config = {};
    }

    const type = config.type;
    const from = config.from;
    const n = 16;
    const uid = 123;
    const title = config.title;
    const id = config.id;

    const data = await jsonp(
        `//c1.m.ifeng.com/client_share_bottom_number?type=${type}&from=${from}&n=${n}&uid=${uid}&title=${title}&id=${id}`,
        {
            jsonpCallback: 'bottomSlideCb',
            cache: false,
        },
    );
    let result = '';

    if (data && data.length !== 0) {
        result = data;
    }

    return result;
};

/**
 * 获取24h relative 列表数据
 * @param pageSize
 * @param pageNum
 */
const getTFHoursList = async (key, pageNum = 1, pageSize = 6) => {
    const listData = await jsonp(`${apiBaseUrl}/tfhoursmodel/${key}/${pageNum}/${pageSize}/getTFHoursList`, {
        // jsonpCallback: `getTFHoursList${key}`,
        jsonpCallback: 'getTFHoursList',
        cache: 120,
    });

    const data = listData.data;

    if (!data) {
        return [];
    }

    // move to sever client for dealing
    // const listTemp = listData.data;

    // console.log('listTemp:', listTemp);

    // const data = listTemp.map(item => ({
    //     type: item.type || '',
    //     base62Id: item.base62Id || '',
    //     guid: item.guid || '',
    //     newStyle: item.newStyle,
    //     title: item.title || '',
    //     summary: item.summary || '',
    //     newsTime: item.newsTime,
    //     thumbnail:
    //         (item.thumbnails &&
    //             item.thumbnails.image &&
    //             item.thumbnails.image[0].url &&
    //             formatImage(item.thumbnails.image[0].url, 226, 150)) ||
    //         (item.thumbnail && formatImage(item.thumbnail, 226, 150)) ||
    //         '',
    //     url: item.url,
    // }));

    if (data && data.length > 0) {
        return data;
    } else {
        return [];
    }
};

/**
 * 获取火力无限列表数据
 * @param pageSize
 * @param pageNum
 * @returns {Promise<*>}
 */
const getHuoliwuxianList = async (key, pageNum = 1, pageSize = 6) => {
    const listData = await jsonp(
        `${apiBaseUrl}/huoliwuxian/huoliwuxianList/${key}/${pageNum}/${pageSize}/getHuoliwuxianList`,
        {
            jsonpCallback: 'getHuoliwuxianList',
            cache: 120,
        },
    );

    if (!listData.data) {
        return '';
    }

    const imgSize = {
        width: 230,
        height: 164,
    };

    if (key === '75221') {
        imgSize.width = 342;
        imgSize.height = 250;
    }

    const listDataByPage = listData.data;

    const data = listDataByPage.map(item => ({
        type: item.type || '',
        guid: item.guid || '',
        commentUrl: item.commentUrl || '',
        link: GETLINKTYPE(item),
        title: item.title || '',
        src:
            (item.thumbnails &&
                item.thumbnails.image &&
                item.thumbnails.image[0].url &&
                formatImage(item.thumbnails.image[0].url, imgSize.width, imgSize.height)) ||
            (item.thumbnail && formatImage(item.thumbnail, imgSize.width, imgSize.height)) ||
            '',
        url: item.url || '',
    }));

    if (data && data.length > 0) {
        return data;
    } else {
        return [];
    }
};

// 获取社招岗位列表
const getRecruitList = async params => {
    const res = await jsonp(`${apiBaseUrl}/career/recruit/list/${params}/getRecruitTableList`, {
        jsonpCallback: 'getRecruitTableList',
        cache: 120,
    });

    console.log('recruitres==', res);

    return res;
};
// 获取社招岗位详情
const getRecruitDetail = async params => {
    const res = await jsonp(`${apiBaseUrl}/career/recruit/detail/${params}/getRecruitDetail`, {
        jsonpCallback: 'getRecruitDetail',
        cache: 120,
    });

    console.log('recruitdetail==', res);

    return res;
};

// 获取应届生岗位列表
const getGraduateList = async () => {
    const res = await jsonp(`${apiBaseUrl}/career/graduate/getGraduateTableList`, {
        jsonpCallback: 'getGraduateTableList',
        cache: 120,
    });

    return res;
};

// 获取实习生岗位列表
const getCampusList = async (name, type, add) => {
    // eslint-disable-next-line newline-after-var

    const res = await jsonp(`${apiBaseUrl}/career/campus/getCampusTableList`, {
        jsonpCallback: 'getCampusTableList',
        cache: 120,
    });

    return res;
};
const submitCampusResume = async paramsObj => {
    const { jobid, name, gender, education, email, phone, school, year, month, day, sid, rid, birth } = paramsObj;
    const date = new Date(year, month, day);
    const timeStamp = Math.round(date.getTime() / 1000);

    try {
        return await jsonp('https://api.cmpp.v.ifeng.com/resume/submitResume', {
            data: {
                applyName: name,
                applySex: gender,
                applyXueli: education,
                applySchool: school,
                applyEmail: email,
                applyMobile: phone,
                applyBtime: birth,
                jobId: jobid,
                sid,
                rid,
                rt: 'jsonp',
                applyJob: '',
            },
            type: 'get',
            jsonpCallback: 'applyCampus',
            cache: true,
        });
    } catch (e) {
        console.log('submitcampus===', e);
        console.error(e);
    }
};

// 提交社招简历
const submitRecruitResume = async paramsObj => {
    const { jobid, name, gender, education, email, phone, school, year, month, day, birth, attachId } = paramsObj;
    const today = new Date();

    const y = today.getFullYear();
    const m = today.getMonth() + 1;
    const d = today.getDate();
    const updatetime = `${y}-${m}-${d}`;
    const datainfo = {
        jobid,
        name,
        gender,
        birthday: birth,
        education,
        email,
        phone,
        attfile: attachId,
        source: '官网',
        updatetime,
        college: school,
        addr: '',
        status: '',
        headpic: '',
    };
    // encodeURIComponent(JSON.stringify(params));
    const params = encodeURIComponent(JSON.stringify(datainfo));

    console.log('submitre===', params);
    const res = await jsonp(`${apiBaseUrl}/career/recruit/apply/${params}/applyRecruit`, {
        jsonpCallback: 'applyRecruit',
        cache: 120,
    });

    console.log('submitRecruitResume==', res);

    return res;
};

/**
 * 自媒体主页获取自媒体账号详情接口
 * @param {Number} cid 自媒体账号id
 * @returns {Object} accountDetail,自媒体账户信息
 */
const getShareAccountDetail = async cid => {
    const accountDetail = await jsonp(`${apiBaseUrl}/ishare/getAccountInfo/${cid}/getShareAccountDetail`, {
        jsonpCallback: 'getShareAccountDetail',
        cache: 120,
    });

    if (accountDetail.code === 0 && accountDetail.data && accountDetail.data.success) {
        return accountDetail.data;
    }

    return accountDetail.data;
};

/**
 * 获取自媒体主页文章或视频列表数据
 * @param {String} id 自媒体账号ID
 * @param {String} type 类型
 * @param {Number} page 页码
 * @returns {Array} 返回数组
 */
const getShareListData = async params => {
    const { id, type, page } = params;

    const listData = await jsonp(`${apiBaseUrl}/ishare/getShareListData/${id}/${type}/${page}/getListData`, {
        jsonpCallback: 'getListData',
        cache: 120,
    });

    return listData;
};

// 获取算法推荐信息流
const getAlgorithmicRecommStream = async uid => {
    try {
        return await ajax('https://lapuda.ifeng.com/api/article/getStream', {
            data: {
                uid,
            },
            type: 'get',
            cache: false,
        });
    } catch (e) {
        console.error(e);
    }
};

const getARArticle = async ({ uid, aid, trans }) => {
    try {
        return await ajax('https://lapuda.ifeng.com/api/article/getStreamArticle', {
            data: {
                uid,
                aid,
                trans,
            },
            type: 'get',
            cache: true,
        });
    } catch (e) {
        console.error(e);
    }
};

// 算法推送统计
const sendStatistics = async ({ uid, aid, trans, type }) => {
    try {
        return await ajax('https://lapuda.ifeng.com/api/article/statistics', {
            data: {
                uid,
                aid,
                trans,
                type,
            },
            type: 'get',
            cache: false,
        });
    } catch (e) {
        console.error(e);
    }
};

// 请求视频
const getVideoPlayUrl = async guid => {
    try {
        const res = await jsonp(`//shankapi.ifeng.com/feedflow/getVideoAuthUrl/${guid}/getVideoAuthPath`, {
            jsonpCallback: 'getVideoAuthPath',
            cache: true,
        });

        if (res.data && res.data.authUrl) {
            return res.data.authUrl;
        } else {
            return;
        }
    } catch (e) {
        console.error(e);
    }
};

// 获取自媒体文章主页数据
const getWeMediaMainData = async params => {
    const data = await jsonp('//c1.m.ifeng.com/api_wemedia_index', {
        data: params,
        jsonpCallback: 'showData',
        cache: false,
    });

    return data ? data : null;
};

const getHotNewsApiParams = () => {
    const defaultParams =
        'page=1&gv=6.8.11&av=6.8.11&uid=ee988cd23e3159dc&deviceid=ee988cd23e3159dc&proid=ifengnewsh5&os=android_29&df=androidphone&vt=5&screen=1080x1794&publishid=develop&nw=wifi&st=15712118293739&sn=0a19d617448ff2f0bd9df7497f80a4e3&dlt=40.011686&dln=116.497205&dcy=%25E5%258C%2597%25E4%25BA%25AC%25E5%25B8%2582&dpr=%25E5%258C%2597%25E4%25BA%25AC%25E5%25B8%2582&skinid=default&isnoad=1';
    const search = defaultParams.replace('?', '').split('&');
    const params = {};

    search.forEach(item => {
        const data = item.split('=');

        params[data[0]] = data[1];
    });

    return params;
};

export const formatHotNewsData = (listData, callUp) => {
    const typesMap = {
        doc: 'article',
        phvideo: 'video',
    };

    return listData.map(item => {
        return {
            ...item,
            source: item.source || (item.subscribe && item.subscribe.catename) || '',
            commentUrl: item.commentsUrl,
            base62Id: item.id.replace('ucms_', ''),
            callUp,
            newStyle: item.style.view,
            newstype: item.type,
            thumbnails: { image: item.style.images && item.style.images.map(item => ({ url: item })) },
            url: callUp ? item.link.url : item.link.weburl,
            clickCount: {
                behavior: 'action',
                type: 'openNewsapp',
                other: {
                    ref: `${item.id}`,
                    kind: 'article',
                },
            },
            downloads: {
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
            },
            type: typesMap[item.type] || item.type,
            duration: item.phvideo && item.phvideo.length,
        };
    });
};

// 热点聚焦分享页
const getHotNewsData = async ({ page, PAGE_INFO }) => {
    const params = getHotNewsApiParams();

    // TODO: use jsonp before deploy!!
    const res = await jsonp(PAGE_INFO.api, {
        type: PAGE_INFO.method,
        data: Object.assign(params, {
            page,
            isnoad: 1, // 滤除广告
            ...PAGE_INFO.params,
        }),
        cache: false,
        jsonpCallback: 'getHotNewsDataCallback',
    });

    if (res?.data?.list && !PAGE_INFO.noFormatData) res.data.list = formatHotNewsData(res.data.list, undefined);

    return res;
};

// 单个热点聚焦分享页
const getHotNewsSingleData = async () => {
    const params = getHotNewsApiParams();
    const eventName = window.location.search
        .match(/(\?|&)eventName=([^&])+(&|$)/)[0]
        .replace(/&|\?/g, '')
        .split('=')[1];

    const res = await jsonp('https://c1.m.ifeng.com/hotSpotDetailList', {
        type: 'get',
        data: Object.assign(params, {
            eventName,
            isnoad: 1, // 滤除广告
            startfrom: 'outside', // 防止空list字段
        }),
        cache: false,
        jsonpCallback: 'getHotNewsSingleDataCallback',
    });

    // if (!res.length) window.location.href = 'https://ishare.ifeng.com/404';

    res[0].item = formatHotNewsData(res[0].item, undefined);

    return res;
};

// 热点聚焦详情页
const getHotNewsDetailData = async params => {
    return await jsonp('https://api.iclient.ifeng.com/hotSpotDetailList', {
        data: params,
        type: 'get',
        cache: false,
    });
};

// 疫情页分享数
const getVoteNum = async key => {
    const data = await jsonp('//survey.news.ifeng.com/api/getaccumulatorweight', {
        data: {
            format: 'js',
            key,
            serviceid: 2,
        },
        jsonpCallback: 'getaccumulator',
        cache: false,
    });

    return data.data && data.data.browse && data.data.browse[key] ? data.data.browse[key] : '';
};

// 疫情分享
const vote = async key => {
    const data = await jsonp('//survey.news.ifeng.com/api/accumulator', {
        data: {
            format: 'js',
            key,
        },
        jsonpCallback: 'accumulator',
        cache: false,
    });

    return data.code === 1;
};

// 疫情分享数设置
const voteSet = async (key, num) => {
    const data = await jsonp('//survey.news.ifeng.com/api/increby', {
        data: {
            format: 'js',
            key,
            num,
        },
        jsonpCallback: 'setto',
        cache: false,
    });

    return data;
};

// 疫情地方内容
const getAreaContent = async (prov, id) => {
    const data = await jsonp(`https://shankapi.ifeng.com/c/api/getAreaContent/${id}/20/${prov}`, {
        jsonpCallback: prov,
        cache: false,
    });

    if (data.code === 0 && data.data && data.data.length > 0) {
        return data.data;
    }

    return [];
};

export {
    getTopicData,
    getCommentData,
    getQueryString,
    wxShareData,
    getSpecialData,
    getWeMediaPersonalData,
    getWeMediaPersonalDetailData,
    getCommitDataApi,
    getIfengNewsTopicData,
    bottomSlideData,
    getTFHoursList,
    getHuoliwuxianList,
    getRecruitList,
    getGraduateList,
    getRecruitDetail,
    getCampusList,
    submitCampusResume,
    submitRecruitResume,
    getShareAccountDetail,
    getShareListData,
    getAlgorithmicRecommStream,
    getARArticle,
    sendStatistics,
    getVideoPlayUrl,
    getWeMediaMainData,
    getHotNewsData,
    getHotNewsDetailData,
    getHotNewsSingleData,
    getVoteNum,
    vote,
    voteSet,
    getAreaContent,
};
